<template>
    <o-card :title="$t('medtastic.contact')" class="col-lg-8 m-auto d-block" :enable-back="true">
        <div class="mb-3">
            <p class="pre-formatted">
                {{ $t('medtastic.contact_text') }}
            </p>
            <p>
                medtastic GmbH<br>
                Minervastrasse 25<br>
                8032 Zürich<br>
                {{ $t('core.phone') }}: 044 552 25 45<br>
                {{ $t('core.email') }}: <a href="mailto:contact@medtastic.ch">contact@medtastic.ch</a>
            </p>
        </div>
    </o-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    layout: 'user',
    computed: {
      ...mapGetters({
        user: 'auth/user'
      })
    }
  }
</script>
